/* eslint-disable react/destructuring-assignment */
import { apis } from '@doltech/core/lib/api/api.config';
import { requestIdleCallbackForSafari } from '@doltech/utils/lib/platform';
import * as React from 'react';
import { apiPublicUrls } from '@doltech/core/lib/api/api.public-urls';

export const updateUserView = async (pageId) => {
  const { data } = await apis.publicPageManagement.put<any>(
    apiPublicUrls.pageManagement.UPDATE_USER_INTERACTION,
    {
      type: 'VIEW',
      id: pageId,
    }
  );
  return data;
};

export const withUpdateViewCount = (Component: any) => (props: any) => {
  React.useEffect(() => {
    window.addEventListener('load', () => {
      requestIdleCallbackForSafari(() => {
        if (typeof window === 'undefined') return;
        if (props?.pageProps?.urlInfo?.id) {
          updateUserView(props?.pageProps?.urlInfo?.id);
        }
      });
    });
  }, [props?.pageProps?.urlInfo?.id]);
  return <Component {...props} />;
};
